import React from 'react'
import {connect} from 'react-redux'
import {Field, reduxForm} from 'redux-form'
import Loader from "./Loader"
import ProductInput from "./ProductInput"
import {locale} from '../locale/AppLocale';
import trim from 'validator/lib/trim';
import isEmpty from 'validator/lib/isEmpty';
import Modal from 'react-modal';
import * as authActions from '../actions/authActions';
import {NotificationManager} from '../Helpers/NotificationManager';
import {go as routerGo} from 'react-router-redux'

import Config from '../Helpers/Config';
import axios from 'axios';


const customStyles = {
    overlay: {
        backgroundColor: 'none'
    },
    content : {
        width:400,
        overflow                   : '',
        top                   : '',
        left                  : '',
        right                 : '',
        bottom                : '',
        marginRight           : '',
        transform             : '',
        padding             : '',
        border             : '',
        background             : '',
        borderRadius             : '',
    }
};

const validateLogin = (values, props) => {
    const errors = {};

    if (!values.email || isEmpty(trim(values.email))) {
        errors.email = locale.get('email_is_required');
    }

    if (!values.password || isEmpty(trim(values.password))) {
        errors.password = locale.get('password_is_required');
    }
    return errors;
}

class LoginPopup extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            modalIsOpen: true
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(values) {
        validateLogin(values);
        window.__x = this.props;
        this.props.login(values,(dataStatus) => {

            if(this.props.auth.relogin_reload){
                this.props.reloadCurrentPage(this.props.router.location.pathname);
            }else{
                NotificationManager.success(locale.get('relogin_success'))
            }

        })
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    afterOpenModal() {
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    render(){

        if(this.props.auth.requires_relogin === false){
            return null;
        }

        let hint ;

        if(!this.props.auth.user.confirmed_email){
            hint = (
                <div  className="hint-1">
                    {locale.get('your_account_requires_email_activation')}
                    <button type="button" className="btn-2 btn--small"
                            style={{
                                margin:'15px 0 0  0'
                            }}
                            onClick={()=>this.resendConfirmation()}>{locale.get('resend')}</button>
                </div>
            )
        }else{
            hint = <p className="hint-1">{locale.get('relogin_to_your_account_hint')}</p> ;
        }

        return (
            <Modal
                portalClassName={'shooq-modal'}
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                style={customStyles}
                contentLabel="Example Modal"
                shouldCloseOnOverlayClick={false}
                ariaHideApp={false}

            >
                <form className="form login-form"
                      onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                    <h5 className="no-tm mb-20">{locale.get('relogin_to_your_account')}</h5>
                    <div className="login-form--body">
                        {hint}
                        <div className="form-group has-feedback has-feedback-left login-email-c ">
                            <Field
                                type="text"
                                name="email"
                                id="email"
                                component={ProductInput}
                                className="input"
                                placeholder={locale.get('email_or_mobile')}
                                field={{}}
                                required="required"/>
                            <div className="form-control-feedback">
                                <i className="zicon-user"></i>
                            </div>
                        </div>
                        <div className="form-group has-feedback has-feedback-left ">
                            <Field
                                type="password"
                                name="password"
                                id="password"
                                component={ProductInput}
                                className="input"
                                placeholder={locale.get('password')}
                                field={{}}
                                required="required"/>

                            <div className="form-control-feedback">
                                <i className="zicon-key"></i>
                            </div>

                        </div>
                        <div className="form-group login-options clearfix ptb-5">
                            <label className="remember-me-c">
                                <Field
                                    type="checkbox"
                                    name="remember"
                                    id="remember"
                                    component={ProductInput}
                                    className=""
                                    label={locale.get('remember_me')}
                                    placeholder={locale.get('remember_me')}
                                    field={{}}
                                />
                            </label>
                            <a href="https://shooq.co.il/user/forgot-password"
                               title="نسيت كلمة المرور؟" className="login-forgot-btn"> نسيت
                                كلمة
                                المرور؟ </a>
                        </div>
                        <div className="form-group">
                            <button type="submit" disabled={this.props.auth.logging} className={`btn-1 btn--block ${this.props.auth.logging?'active':''}`}>
                                <Loader completed={this.props.auth.logged}>
                                    تسجيل الدخول
                                </Loader>
                            </button>
                        </div>

                        <div className="login-divider"><span>أو سجل الدخول من خلال</span></div>

                        <iframe className="social-login-frame" scrolling="no"
                                src="https://accounts.shooq.co.il/auth/facebook-btn?param=lg"></iframe>
                    </div>

                </form>
            </Modal>
        )

    }

    resendConfirmation(){


        axios.get(Config.mainUrl('user/ajax/send/email-confirmation'),{
            withCredentials:Config.withCredentials(),
            headers: {'X-Requested-With': 'XMLHttpRequest'}

        }).then((response) => {
                NotificationManager.success(response.data.message);
        }).catch((error) => {

            NotificationManager.error(error.response.data.message);

            // if(error.response.status === 401) {
            //     this.props.requiresReLogin();
            // }else{
            //     NotificationManager.error(locale.get('an_error_occurred_while_submitting_form'));
            // }
            // this.props.toggleFormActionStatus(false);
        });
    }
    componentDidMount() {
        const receiveMessage = (event) => {

            this.props.facebookLoginFailed();

            if(event){
                if (event.data === 'facebook_logged_in') {
                    if(this.props.auth.relogin_reload){
                        this.props.reloadCurrentPage(this.props.router.location.pathname);
                    }else{
                        this.props.check()
                        NotificationManager.success(locale.get('relogin_success'))
                    }
                } else {
                    // NotificationManager.error(locale.get('facebook_login_failed'))
                }
            }
        };

        if (window.addEventListener) {
            window.addEventListener("message", receiveMessage, false);
        } else {
            window.attachEvent("onmessage", receiveMessage);
        }
    }

}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth,
        router:state.router
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch,ownProps,ownProps12) => {
    return {
        login: (data,callback = ()=>{}) => dispatch(authActions.login(data,callback,false)),
        check: () => dispatch(authActions.check()),
        facebookLoginFailed: () => dispatch({
            type: 'AUTH_LOGIN_FAILED',
            results: {}
        }),
        reloadCurrentPage: (pathname) => dispatch(routerGo("/heijar-tailoring-store/orders/2"))
    }
};
LoginPopup = reduxForm({
    form: 'loginForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    touchOnChange: true,
    validate: validateLogin,
})(LoginPopup);

export default connect(mapStateToProps, mapDispatchToProps)(LoginPopup);
